// extracted by mini-css-extract-plugin
export default {"wrapper":"contest-item-home_wrapper__N9nTb"};